import React from "react";
import ReviewStep from "./ReviewStep";
import { useOnboarding } from "context/OnboardingContext";

const EntityReview = () => {
  const { claimMeta } = useOnboarding();
  const claimLabel = claimMeta?.claim_type === "build_device"
    ? "Build + Device"
    : claimMeta?.claim_type === "device"
    ? "Device"
    : "Build";

  return (
    <ReviewStep
      stepKey="entity"
      title={`${claimLabel} Details`}
      fields={[
        { name: "name", label: "Company Name" },
        { name: "entity_type_id", label: "Entity Type ID" },
      ]}
    />
  );
};

export default EntityReview;
